import { render, staticRenderFns } from "./PriceManagement.vue?vue&type=template&id=bd267c48"
import script from "./PriceManagement.vue?vue&type=script&lang=js"
export * from "./PriceManagement.vue?vue&type=script&lang=js"
import style0 from "./PriceManagement.vue?vue&type=style&index=0&id=bd267c48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports